import { resolveSwingIconUrl } from './resolvePlatformIcon'

/**
 * Label XML image: Swing PNG URL.
 * Do not use Prime mapping — colored bullets would lose their color.
 */
export function resolveSimpleLabelSwingImageUrl(imageName: string): string {
  const name = String(imageName ?? '').trim()
  if (!name) return ''
  return resolveSwingIconUrl(name) ?? ''
}

/** XML font size for Label, as CSS px. */
export function resolveXmlLabelFontSizePx(raw: string): string | undefined {
  const fontSize = Number(String(raw ?? '').trim())
  if (!Number.isFinite(fontSize) || fontSize <= 0) return undefined
  return `${fontSize}px`
}
